import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component
export default class LocalizationMixin extends Vue {
    private localeItems: any[] = [];
    private locale: string = 'ja';
    private titleKey = '';

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    private get locales(): string[] {
        return this.$i18n.availableLocales;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    async created() {
        // 表示言語をクエリパラメーターから取得する
        const currentUrl = new URL(location.href);
        const locale = currentUrl.searchParams.get('locale');
        this.locale =  locale && this.locales.includes(locale) ? locale : this.$i18n.fallbackLocale;
    }

    mounted() {
        // 言語変換メニュー生成
        this.$i18n.locale = this.locale;
        document.title = this.$t(this.titleKey) as string;
        this.makeTranslateMenu();
    }

    /*----------------------------------*
     * Functions
     *-----------------------------------*/
    /* 言語変換メニュー生成 */
    private makeTranslateMenu(): void {
        const localeItems: {value: string, text: string}[] = [];

        Array.prototype.forEach.call(this.locales, (locale: string) => {
            localeItems.push({
                value: locale,
                text: this.$t('main.translate.' + locale) as string,
            });
        });
        localeItems.reverse();

        this.localeItems = localeItems;
    }

    /*----------------------------------*
     * Watch
     *-----------------------------------*/
    @Watch('locale')
    private setLocale() {
        this.$i18n.locale = this.locale;
        document.title = this.$t(this.titleKey) as string;
        this.makeTranslateMenu();
    }
}
